<div class="white_round padding16 cpers_container">
    <div *ngFor="let iReaction of us.currentUser.reactions" class="cpers_item">
        <app-button-single-line-arrow [icon]="iReaction.image" [fixedColor]="true" [withPadding]='false' (click)="editReaction(iReaction)">{{iReaction.default_name ? trans('reactionNames.reactions.' + iReaction.name) : iReaction.name}}</app-button-single-line-arrow>
    </div>
</div>
